export default __webpack_public_path__ + "static/media/seo-bw.54dea408.png";